import { ChevronLeftIcon, ChevronRightIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { SEARCH_LABEL, SEARCH_PLACEHOLDER } from '../vacationManagementPage.definitions';

export interface VacationDpToolbarProps {
    search: string;
    onSearchChange: (value: string) => void;
    selectedClient?: string | null;
    onClientChange?: (value: string | null) => void;
    clientOptions?: Array<{ value: string; label: string; count: number }>;
    isSidebarCollapsed: boolean;
    onToggleSidebar: () => void;
}

export function VacationDpToolbar({
    search,
    onSearchChange,
    selectedClient,
    onClientChange,
    clientOptions = [],
    isSidebarCollapsed,
    onToggleSidebar,
}: VacationDpToolbarProps) {
    return (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <div className="relative sm:max-w-xs sm:flex-1" data-tour="dp-search">
                <MagnifyingGlassIcon
                    className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-raro-gray-400"
                    aria-hidden="true"
                />
                <input
                    type="search"
                    aria-label={SEARCH_LABEL}
                    placeholder={SEARCH_PLACEHOLDER}
                    value={search}
                    onChange={(event) => onSearchChange(event.target.value)}
                    className="w-full rounded-xl border border-raro-gray-200 py-2 pl-9 pr-3 text-sm text-raro-gray-900 placeholder:text-raro-gray-400 focus:border-primary-500 focus:ring-primary-500 font-montserrat"
                />
            </div>

            <div className="flex flex-wrap items-center gap-2">
                <div className="flex flex-wrap items-center gap-2" data-tour="dp-filters">
                    {onClientChange && clientOptions.length > 0 && (
                        <select
                            value={selectedClient || ''}
                            onChange={(e) => onClientChange(e.target.value || null)}
                            className="rounded-full border border-raro-gray-200 bg-white px-3 py-2.5 text-sm font-montserrat focus:border-primary-500 focus:ring-primary-500"
                            data-tour="dp-client"
                        >
                            <option value="">Todos os clientes</option>
                            {clientOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label} ({opt.count})
                                </option>
                            ))}
                        </select>
                    )}
                </div>

                <button
                    type="button"
                    onClick={onToggleSidebar}
                    aria-expanded={!isSidebarCollapsed}
                    title={isSidebarCollapsed ? 'Expandir filtros' : 'Recolher filtros'}
                    className="hidden h-10 w-10 items-center justify-center rounded-lg border border-raro-gray-200 bg-white p-2 text-raro-gray-600 transition-colors hover:border-raro-gray-300 hover:bg-raro-gray-50 hover:text-raro-gray-700 lg:flex"
                >
                    {isSidebarCollapsed ? (
                        <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" />
                    ) : (
                        <ChevronRightIcon className="h-4 w-4" aria-hidden="true" />
                    )}
                    <span className="sr-only">{isSidebarCollapsed ? 'Expandir filtros' : 'Recolher filtros'}</span>
                </button>
            </div>
        </div>
    );
}

export default VacationDpToolbar;
